import { Grid } from '@mui/material';
import { CerebroDrawer, CerebroHeading, CerebroLabel, CerebroText } from '../../../shared/components';
import { ContactDetailUser, AssociatedTeamMember, DataRoomUser } from '../../../shared/models';
import React from 'react';
import { useBankDealProfileQuery } from '../../../shared/hooks';
import { BankDealProfileLayout } from '../../../shared/components/BankDealProfileLayout';

interface IContactDetailsProps {
	roomGuid: string | undefined;
	teamMember?: AssociatedTeamMember | null;
	roomUser?: DataRoomUser | null;
	close: () => void;
}

export const ViewContactDetails: React.FC<IContactDetailsProps> = ({ roomGuid, teamMember, roomUser, close }) => {
	const user = teamMember ? (teamMember as ContactDetailUser) : (roomUser as ContactDetailUser);
	const dealProfileQuery = useBankDealProfileQuery(roomGuid, roomUser?.guid, {
		enabled: roomUser != null,
		retry: false,
	});

	return (
		<CerebroDrawer open={user != null} onClose={() => close()} PaperProps={{ sx: { width: '700px' } }}>
			<CerebroHeading>
				{user?.firstName} {user?.lastName}
			</CerebroHeading>
			<CerebroText variant="large" sx={{ fontWeight: 'bold' }}>
				{user?.bankName}
			</CerebroText>

			<Grid container spacing={3} sx={{ marginTop: 3, marginBottom: 3 }}>
				<Grid item xs={8}>
					<CerebroLabel>Email</CerebroLabel>
					<CerebroText>{user?.emailAddress}</CerebroText>
				</Grid>

				{user?.phone && (
					<Grid item xs={8}>
						<CerebroLabel>Phone</CerebroLabel>
						<CerebroText>{user?.phone}</CerebroText>
					</Grid>
				)}
			</Grid>

			<BankDealProfileLayout dealProfileQuery={dealProfileQuery} />
		</CerebroDrawer>
	);
};
